import React, { useState } from "react";

import { useIntl } from "react-intl";
import { Outlet } from "react-router-dom";

import config from "console_config";
import { APP_NAME } from "Constants/documentationUrls";
import Meta from "src/root/pages/components/Meta";
import NavBar from "src/root/pages/components/NavBar";
import { redirectIfAuthenticated } from "src/root/pages/utils/cookie";

import DefaultLogin from "./default";
import { LoginProvider } from "./LoginProvider";
import * as S from "./styles";

// @TODO: this could be a hook
const Redirection = () => {
  redirectIfAuthenticated();
  return false;
};

const Login = () => {
  const intl = useIntl();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [step, setStep] = useState(0);

  return (
    <LoginProvider.Provider
      value={{
        email,
        setEmail,
        password,
        setPassword,
        step,
        setStep,
        onLoginSuccess: () => {}
      }}
    >
      <S.LoginLayout>
        <Redirection />
        <Meta
          title={intl.formatMessage(
            { id: "log_in_title" },
            { app_name: APP_NAME }
          )}
        >
          <link rel="canonical" href={config.URL_AUTH} />
        </Meta>
        <DefaultLogin />
        <S.RightPaneLayout>
          <div>
            <NavBar color="black" />
            <Outlet />
          </div>
        </S.RightPaneLayout>
      </S.LoginLayout>
    </LoginProvider.Provider>
  );
};

export default Login;
